export const stripIdsFromUrl = (url: string): string =>
  url
    .replace(
      /\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi,
      '/:uuid',
    )
    .replace(/\/\d+/g, '/:id');
